import { render, staticRenderFns } from "./CountdownBadge.vue?vue&type=template&id=1dfa0037"
import script from "./CountdownBadge.vue?vue&type=script&lang=js"
export * from "./CountdownBadge.vue?vue&type=script&lang=js"
import style0 from "./CountdownBadge.vue?vue&type=style&index=0&id=1dfa0037&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports